"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _LinkFields = _interopRequireDefault(require("./LinkFields"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _url = require("../../utils/url");

var _UIFieldset = _interopRequireDefault(require("UIComponents/form/UIFieldset"));

var _link = require("../../constants/link");

var _popover = require("../../constants/popover");

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links." + suffix;
};

var InsertLinkPopoverBody =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(InsertLinkPopoverBody, _Component);

  function InsertLinkPopoverBody(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InsertLinkPopoverBody);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InsertLinkPopoverBody).call(this, props));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUrlKeyDown = _this.handleUrlKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(InsertLinkPopoverBody, [{
    key: "handleKeyDown",
    value: function handleKeyDown(keyEvt) {
      if (keyEvt.key === _popover.KeyTypes.ESCAPE) {
        this.props.onClose();
      }
    }
  }, {
    key: "handleUrlKeyDown",
    value: function handleUrlKeyDown(keyEvt) {
      if (keyEvt.key === _popover.KeyTypes.ENTER && this.canInsert()) {
        this.props.onInsert();
      }
    }
  }, {
    key: "canInsert",
    value: function canInsert() {
      var _this$props = this.props,
          href = _this$props.href,
          linkText = _this$props.linkText;
      return !((0, _url.isWhitespace)(href) || (0, _url.isWhitespace)(linkText));
    }
  }, {
    key: "renderLinkTextInput",
    value: function renderLinkTextInput() {
      var _this$props2 = this.props,
          linkText = _this$props2.linkText,
          canModifyLinkText = _this$props2.canModifyLinkText,
          onUpdate = _this$props2.onUpdate;
      if (!canModifyLinkText) return null;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey("linkTypes.linkText.label")),
        className: "m-bottom-1"
      }, _react.default.createElement(_UITextInput.default, {
        autoFocus: canModifyLinkText,
        "data-test-id": "link-text-input",
        value: linkText,
        onChange: function onChange(_ref) {
          var value = _ref.target.value;
          onUpdate({
            linkText: value
          });
        },
        placeholder: _I18n.default.text(i18nKey('linkTypes.linkText.placeholder'))
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          fetchPages = _this$props3.fetchPages,
          fetchMeetings = _this$props3.fetchMeetings,
          fetchAnchors = _this$props3.fetchAnchors,
          onSelectFile = _this$props3.onSelectFile,
          onClose = _this$props3.onClose,
          showRefAndTargetControls = _this$props3.showRefAndTargetControls,
          useEmailSubscription = _this$props3.useEmailSubscription,
          allowFileDownload = _this$props3.allowFileDownload,
          allowMeetingLink = _this$props3.allowMeetingLink,
          allowAnchorLinks = _this$props3.allowAnchorLinks,
          onUpdate = _this$props3.onUpdate,
          onLinkTypeChange = _this$props3.onLinkTypeChange,
          onInsert = _this$props3.onInsert,
          href = _this$props3.href,
          externalLink = _this$props3.externalLink,
          noFollow = _this$props3.noFollow,
          linkType = _this$props3.linkType,
          fileMeta = _this$props3.fileMeta,
          dropdownClassName = _this$props3.dropdownClassName,
          canModifyLinkText = _this$props3.canModifyLinkText,
          scopes = _this$props3.scopes,
          userId = _this$props3.userId;
      return _react.default.createElement("div", {
        className: "p-x-5 p-y-3",
        onKeyDown: this.handleKeyDown
      }, _react.default.createElement(_UIFieldset.default, {
        _size: "small",
        className: "small-popover-body m-y-3 m-x-2"
      }, _react.default.createElement("h4", {
        className: "m-bottom-2"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('insertLink')
      })), this.renderLinkTextInput(), _react.default.createElement(_LinkFields.default, {
        externalLink: externalLink,
        dropdownClassName: dropdownClassName,
        noFollow: noFollow,
        href: href,
        onUpdate: onUpdate,
        onLinkTypeChange: onLinkTypeChange,
        onUrlKeyDown: this.handleUrlKeyDown,
        fetchPages: fetchPages,
        fetchMeetings: fetchMeetings,
        fetchAnchors: fetchAnchors,
        linkType: linkType,
        onSelectFile: onSelectFile,
        showRefAndTargetControls: showRefAndTargetControls,
        currentFileMeta: fileMeta,
        useEmailSubscription: useEmailSubscription,
        allowFileDownload: allowFileDownload,
        allowMeetingLink: allowMeetingLink,
        allowAnchorLinks: allowAnchorLinks,
        shouldAutoFocus: !canModifyLinkText,
        scopes: scopes,
        userId: userId
      }), _react.default.createElement("div", {
        className: "m-top-4"
      }, _react.default.createElement(_UIButton.default, {
        use: "primary",
        "data-test-id": "insert-link-confirm-button",
        onClick: onInsert,
        disabled: !this.canInsert(),
        size: "small"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('addLink')
      })), _react.default.createElement(_UIButton.default, {
        use: "secondary",
        onClick: onClose,
        size: "small"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('cancelInsert')
      })))));
    }
  }]);
  return InsertLinkPopoverBody;
}(_react.Component);

exports.default = InsertLinkPopoverBody;
InsertLinkPopoverBody.propTypes = {
  onInsert: _react.PropTypes.func.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  fetchPages: _react.PropTypes.func.isRequired,
  fetchMeetings: _react.PropTypes.func.isRequired,
  fetchAnchors: _react.PropTypes.func.isRequired,
  href: _react.PropTypes.string.isRequired,
  externalLink: _react.PropTypes.bool.isRequired,
  noFollow: _react.PropTypes.bool.isRequired,
  linkText: _react.PropTypes.string.isRequired,
  onSelectFile: _react.PropTypes.func.isRequired,
  showRefAndTargetControls: _react.PropTypes.bool.isRequired,
  useEmailSubscription: _react.PropTypes.bool,
  allowFileDownload: _react.PropTypes.bool,
  allowMeetingLink: _react.PropTypes.bool,
  allowAnchorLinks: _react.PropTypes.bool,
  onUpdate: _react.PropTypes.func.isRequired,
  onLinkTypeChange: _react.PropTypes.func.isRequired,
  dropdownClassName: _react.PropTypes.string,
  fileMeta: _react.PropTypes.object,
  linkType: _react.PropTypes.oneOf((0, _link.getAllLinkTypesForProps)()),
  canModifyLinkText: _react.PropTypes.bool.isRequired,
  scopes: _react.PropTypes.array,
  userId: _react.PropTypes.number
};
module.exports = exports.default;